module.exports = __webpack_public_path__ + "img/logo-spin1.fda9a571.png";